/* eslint-disable no-case-declarations, guard-for-in, consistent-return, no-use-before-define, no-restricted-syntax, max-len */
import axios, { AxiosResponse } from 'axios';
import { MessageBox as Message } from 'element-ui';
import $i18n from '../lang'; // 取得多國文本
import utilErrorCodes from '../const/utilErrorCodes';
import store from '@/modules/FPKG-50000-Vuex';
import router from '../vueRouter';


/** 初始化的 Domain 指向測試機 */
let rawDomain: string = 'default.tw';
/** 是否接到正式機 API，若是，source 指向目前網址 */
if (process.env.VUE_APP_URL) rawDomain = window.location.hostname;
/** 是否有自訂 SOURCE ，若是 則覆蓋自訂 SOURCE 進入正式檔案 DEV 模式(正式機救火模式) */
if (process.env.VUE_APP_SOURCE) rawDomain = process.env.VUE_APP_SOURCE;

export const domain = rawDomain;

export const options = {
  timeout: 100000,
  headers: {
    // 'X-Branch-Source': domain,
  },
  /** 環境變數偵測 */
  // baseURL: process.env.VUE_APP_URL || 'http://fed-point.mirfak.tw',
  // baseURL: process.env.VUE_APP_URL || 'http://notfi.hackfbg.net',
  baseURL: process.env.VUE_APP_URL || 'https://api.cu6666.cc',

};


axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

const Axios = axios.create(options);

Axios.interceptors.request.use((config: any) => {
  const configData = config;
  const authorisation = localStorage.getItem('x-authorisation');
  configData.headers['x-authorisation'] = authorisation;
  if (configData.url !== 'frontendAdapter/common/info') {

    store.dispatch('openLoading');
  }
  // 紀錄當前時間
  const now = new Date().getTime();
  const timestamp = Math.floor(now / 1000);
  localStorage.setItem('timestamp', String(timestamp));

  return configData;
},
  (error: object) => Promise.reject(error));

Axios.interceptors.response.use((response: any) => {
  const noHud = response.config.url !== `${response.config.baseURL}/frontendAdapter/common/info`;
  store.dispatch('closeLoading');

  if (response.status !== 200) {
    return;
  }

  /** 例外的處理，不包含alert */
  exceptionHandle(response);

  /** 共用錯誤alerter */
  alerter(response.data.code);

  return response;
}, (error: object) => Promise.reject(error));


export default Axios;

/*
* 此處引入 router 會報 Maximum call stack size exceeded
* 所以使用window.location.href
*/
/** 進行例外處理動作 */
function exceptionHandle(response: AxiosResponse) {
  switch (response.data.code) {
    case 10015:
      store.dispatch('setLogin', false);
      break;
    case 10012:
      store.dispatch('setLogin', false);
      router.push({ name: 'login' });
      break;
    case 30002:
      store.dispatch('setLogin', false);
      router.push({ name: 'login' });
      break;
    case 20001:
      const data = [];
      for (const res in response.data.response) {
        data.push(response.data.response[res][0]);
      }
      Message.alert(`${data[0]}`);
      break;
    default:
      break;
  }
}


/** 警告器 */
export function alerter(code: number) {
  if (!utilErrorCodes.includes(code)) { return; }
  let msg: any = $i18n.t('Util.error', { code });
  const errorMsg: any = $i18n.t(`Util.${code}`);
  /** 判斷沒有多語言對應時，回傳普通警示 */
  if (errorMsg !== `Util.${code}`) { msg = errorMsg; }
  Message.alert(msg);
}
